module.exports = __webpack_public_path__ + "img/spiral.325cd6f7.png";